<template>
  <div class="page-content">

    <section
      class="
        page-action
      "
      style="
        margin-bottom: 0;
      ">
      <div class="content-wrap">
        <el-button
          type="info"
          icon="
            el-icon-arrow-left
          "
          size="small"
          round
          @click="
            () => fallback()
          ">
          ย้อนกลับ
        </el-button>
      </div>
    </section>

    <section
      class="
        content-wrap action-panel
      "
      style="
        margin: 0 auto;
      ">
      <div panel="main">
        <b>
          นำเข้าข้อมูลบ้าน
        </b>
        <p class="subtitle">
          {{ projectName || 'ชื่อโครงการ' }}
        </p>
      </div>
      <div panel="action" class="action-group">
        <el-button
          type="primary"
          icon="
            el-icon-circle-plus
          "
          plain
          @click="
            () => creator.open = true
          ">
          เพิ่มข้อมูล
        </el-button>
        <el-button
          type="primary"
          icon="
            el-icon-upload
          "
          plain
          @click="
            () => trigger()
          ">
          อัพโหลดข้อมูล
        </el-button>
      </div>
      <input
        type="file"
        :id="
          input.import
        "
        :accept="accept"
        @input="
          () => upload()
        "
      />
    </section>
    
    <section section="content">
      <div
        class="
          content-wrap
        ">
        <div
          v-if="
            record.length > 0
          "
          class="action-group">
          <el-button
            type="success"
            :plain="
              tab != 'ALL'
            "
            @click="
              () => tab = 'ALL'
            ">
            ทั้งหมด <span>({{ record.length }})</span>
          </el-button>
          <el-button
            type="danger"
            :plain="
              tab != 'INVALID'
            "
            :disabled="
              invalid.length == 0
            "
            @click="
              () => tab = 'INVALID'
            ">
            ไม่ถูกต้อง <span v-if="invalid.length > 0">({{ invalid.length }})</span>
          </el-button>
          <el-button
            v-if="
              tab == 'INVALID' && invalid.length > 1
            "
            type="danger"
            icon="
              el-icon-delete
            "
            @click="
              () => clean.open = true
            ">
            ลบทั้งหมด ({{ invalid.length }})
          </el-button>
        </div>

        <div
          v-if="
            record.length == 0
          "
          class="empty">
          <img
            src="@/assets/images/admin/empty.png"
          />
          <p>
            <b class="unknown">
              ไม่พบข้อมูล
            </b>
          </p>
        </div>
        <div v-else>
          <div v-if="tab == 'ALL'">
            <NonScImportList
              :list="items"
              :page="
                paging.items
              "
              @page-change="
                page => paging.items = page
              "
              @update="
                value => update(value)
              "
              @copy="
                id => copy(id)
              "
              @remove="
                id => remove(id)
              "
            />
          </div>
          <div v-if="tab == 'INVALID'">
            <NonScImportList
              :list="invalid"
              :page="
                paging.invalid
              "
              @page-change="
                page => paging.invalid = page
              "
              @update="
                value => update(value)
              "
              @copy="
                id => copy(id)
              "
              @remove="
                id => remove(id)
              "
            />
          </div>
        </div>
      </div>
    </section>

    <section section="action">
      <div
        class="
          content-wrap
        ">
        <div
          class="
            content-action
          ">
          <el-button
            type="primary"
            plain
            @click="
              () => download()
            ">
            ดาวน์โหลดต้นแบบ
          </el-button>
          <el-button
            type="sc-asset"
            :disabled="
              !allow
            "
            @click="
              () => submit()
            ">
            บันทึกข้อมูล
          </el-button>
        </div>
      </div>
    </section>

    <NonScImportEditor
      :title="
        'เพิ่มข้อมูล'
      "
      :mode="
        'creator'
      "
      :form="
        creator.form
      "
      :open="
        creator.open
      "
      @submit="
        value => create(value)
      "
      @closed="
        () => creator.open = false
      "
    />

    <NonScAlert
      :open="
        erase.open
      "
      :type="
        'error'
      "
      :head="
        erase.head
      "
      :message="
        erase.message
      "
      :disabled="
        !erase.id
      "
      :cancel="true"
      @confirm="
        () => eraser(erase.id)
      "
      @closed="
        () => erase.open = false
      ">
    </NonScAlert>

    <NonScAlert
      :open="
        clean.open
      "
      :type="
        'error'
      "
      :head="
        clean.head
      "
      :message="
        clean.message
      "
      :cancel="true"
      @confirm="
        () => cleaner()
      "
      @closed="
        () => clean.open = false
      ">
    </NonScAlert>
    
    <NonScAlert
      :open="
        error.open
      "
      :type="
        'error'
      "
      :message="
        error.message
      "
      @closed="
        () => error.open = false
      "
    />

    <div 
      v-loading.fullscreen.lock="loader"
      element-loading-background="rgba(0, 0, 0, 0.4)">
    </div>
  </div>
</template>

<script>

// Dependencies
import * as xlsx from 'xlsx'

// Components
import NonScAlert from '../../components/NonScAlert.vue'
import NonScImportEditor from './NonScImportEditor.vue'
import NonScImportList from './NonScImportList.vue'

// Common
import {
  NonScCommon as Common
} from '../../common/nonsc.common'

import {
  NonScImportCommon as ImportCommon
} from '../../common/nonsc-home-import.common'

// Services
import { NonScFeature } from '../../feature'

// Utility
import {
  ValidateUtility as Validate
} from '../../utils/validate'

export default {
  components: {
    NonScAlert,
    NonScImportEditor,
    NonScImportList,
  },
  data () {
    return {
      loader: false,
      title: 'รายการบ้าน',
      input: {
        import: 'import-user'
      },
      content: [
        'application/vnd.ms-excel',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      ],
      record: [],
      tab: 'ALL',
      creator: {
        open: false,
        form: null
      },
      erase: {
        open    : false,
        head    : 'ลบข้อมูล',
        message : null,
        id      : null,
      },
      clean: {
        open    : false,
        head    : 'ลบข้อมูล',
        message : 'ต้องการลบข้อมูลไม่ถูกต้องทั้งหมด?',
      },
      error: {
        open    : false,
        type    : 'error',
        message : null,
      },
      project: null,
      paging: {
        items: 1, invalid: 1
      }
    }
  },
  computed: {
    role() {
      return Common.role
    },
    construct() {
      return Common.construct
    },
    header() {
      return NonScFeature.user.fields
    },
    projectId() {
      return this.$route.params.projectId
    },
    projectName() {
      if (this.project) {
        return `โครงการ${this.project.name.tha}`
      }
    },
    accept() {
      return this.content.join(',')
    },
    importer() {
      return document.getElementById(
        this.input.import
      )
    },
    validate() {
      return this.record.map(this.validator)
    },
    invalid() {
      return (
        this.items.filter(
          e => e.valid.all == false
        )
      )
    },
    items() {

      // Text Lower
      const lower = (a) => `${a}`.toLowerCase()

      // Text Sorter
      const sorter = (a, b, key) => (
        lower(a[key]).localeCompare(lower(b[key]))
      )

      return this.record
        .map(this.mapper)
        .map(
          (e, i) => ({
            ...e, valid: this.validator(e, i)
          })
        )
        .sort(
          (a, b) => sorter(a, b, 'addressNo')
        )
    },
    address() {
      return (
        this.project ? this.project.address : null
      )
    },
    uniqueMobileNo() {
      return this.record.map(
        e => `${e.firstName}-${e.lastName}`
      )
    },
    allow() {
      return (
        this.record.length > 0 && this.invalid.length == 0
      )
    }
  },
  watch: {
    invalid(value) {

      // Invalid List Validator
      const isEmpty = (
        Array.isArray(value) && value.length == 0
      )

      // Display Import List
      if (isEmpty) this.tab = 'ALL'
    },
    projectName(name) {
      if (name) {
        this.$emit(
          'sub-title', `${this.title}${name}`
        )
      }
    }
  },
  mounted() {

    // Init Title
    this.$emit(
      'sub-title', this.title
    )

    // Validate Params
    if (!this.projectId) this.fallback()

    // Get Project
    this.getProject(this.projectId)
  },
  methods: {
    isExcel(input) {
      return this.content.includes(input)
    },
    exclude(index) {
      return (
        this.record.filter((_, i) => i != index)
      )
    },
    isUnique(key, index, input) {

      // Unique by Name
      const unique = (e) => (
       `${e[key]}`.concat(e.firstName, e.lastName)
      )

      // Compare Name
      const compare = (e) => (
        unique(e) != unique(input)
      )

      // Set Data Source
      const source = (
        this.exclude(index).filter(compare).map(e => e[key])
      )

      return (
        source.filter(e => !!e).every(e => e != input[key])
      )
    },
    isDuplicated(index, input) {
      
      // Set Unique by Address
      const unique = (e) => (
       `${e.addressNo}`.concat(e.mobileNo)
      )

      // Compare Name
      const compare = (e) => (
        unique(e) == unique(input)
      )

      return (
        this.exclude(index).some(compare)
      )
    },
    async getProject(id) {

      // Open Loader
      this.loader = true
      
      try {

        // Validate ID
        if (!id) {
          throw new Error('Invalid Parameters')
        }
        
        // Fetch Project
        const result = (
          await NonScFeature.project.get(id)
        )

        // Validate Result
        if (!result) {
          throw new Error(
            'Fetch Project Failed'
          )
        }

        // Set Project
        this.project = result

        // Set Creator Form
        this.creator.form = Object.assign(
          {}, ImportCommon.item, result.address
        )
      }
      catch ({ message }) {
        this.fallback(message)
      }
      finally {
        setTimeout(
          () => this.loader = false, 400
        )
      }
    },
    trigger() {
      this.importer.value = null
      this.importer.click()
    },
    download() {
      
      // Create Link
      const link = document.createElement('a')
      
      // Download URL
      link.href = (
        `https://storage.googleapis.com/sca-public/nonsc-management/Comfirm_template.xlsx`
      )

      // Trigger Download
      link.click()
    },
    async upload() {

      // Loading
      this.loader = true

      // Reset Record
      this.record = []

      /** @type {HTMLInputElement} */
      const { files } = this.importer

      // Validate File
      if (files.length == 0) return

      /** @type {FileList} */
      const [file] = files

      // Validate Type
      if (!this.isExcel(file.type)) return

      // File Buffer
      const buffer = await file.arrayBuffer()

      // Read Workbook
      const workbook = xlsx.readFile(
        buffer, { type: 'buffer' }
      )
      
      // Column Keys
      const header = this.header

      // First Sheet
      const sheet = workbook.Sheets[
        workbook.SheetNames[0]
      ]

      // Read Sheet to JSON
      const rows = xlsx.utils.sheet_to_json(
        sheet, {
          defval: null, header, range: 1
        }
      )

      // Set Record
      this.record = (
        rows.filter(e => !!e.mobileNo).map(this.mapper)
      )

      // Loaded
      setTimeout(
        () => this.loader = false, 400
      )
    },
    mapper(item, i) {
      return ImportCommon.map(item, i)
    },
    validator(item, index) {

      // Validate Item
      if (!item) return

      // Valid State
      const valid = (
        ImportCommon.validator(item)
      )
      
      // Validate Unique Mobile No
      valid.mobileNoUnique = this.isUnique(
        'mobileNo', index, item
      )

      // Item Props
      const { email } = item

      // Validate Email
      if (email) {

        // Validate Email
        valid.emailValid = Validate.isEmail(email)

        // Validate Unique Email
        valid.emailUnique = this.isUnique(
          'email', index, item
        )
      }

      // Validate Duplicated
      valid.unique = (
        !this.isDuplicated(index, item)
      )

      // Validate All
      valid.all = [
        valid.name,
        valid.mobileNoUnique,
        valid.mobileNoValid,
        valid.emailUnique,
        valid.emailValid,
        valid.address,
        valid.structure,
        valid.role,
        valid.transferDate,
        valid.unique,
      ].every(e => !!e)

      return valid
    },
    get(id) {
      return this.record.find(
        e => e.id == id
      )
    },
    copy(id) {
      if (this.get(id)) {
        this.create(Object.assign({}, this.get(id)))
      }
    },
    create(value) {
      if (value) {
        this.record.push(value)
      }
    },
    update(value) {

      // Update Index
      const index = this.record.findIndex(
        e => e.id == value.id
      )

      // Validate Index
      if (index > -1) {
        this.record.splice(index, 1, value)
      }
    },
    remove(id) {

      // Validate Item
      if (!this.get(id)) return

      // Item Props
      const { firstName } = this.get(id)
      
      // Confirm Message
      const message = (
        `ต้องการลบข้อมูล ${firstName || ''}?`
      )

      // Set Confirm
      Object.assign(
        this.erase, { open: true, message, id }
      )
    },
    eraser(id) {
      
      // Set Record
      this.record = this.record.filter(
        e => e.id != id
      )
    },
    cleaner() {

      // Validate Invalid
      if (this.invalid.length == 0) return

      // Invalid Validator
      const include = (id) => (
        this.invalid.map(e => e.id).includes(id)
      )

      // Set Record
      this.record = this.record.filter(
        e => !include(e.id)
      )
    },
    async submit() {

      // Loading
      this.loader = true
      
      try {

        // Project Props
        const { code } = this.project

        // Map Payload
        const mapper = (e) => this.header.reduce(
          (item, key) => ({ ...item, [key]: e[key] }), {}
        )

        // Payload Items
        const items = this.record.map(mapper)
        
        // Request Import
        await NonScFeature.user.import(
          code, items
        )

        // Forward Route
        this.fallback()
      }
      catch ({ message }) {

        // Set Error Message
        this.error.message = (
          Common.error(message)
        )

        // Set Error Alert
        this.error.open = true
      }
      finally {
        setTimeout(
          () => this.loader = false, 400
        )
      }
    },
    fallback(message) {
      
      // Fallback Info
      if (message) {
        console.warn(
          'nonsc-import-home.fallback', message
        )
      }

      // Project ID
      const projectId = this.projectId
      
      // Fallback Route
      this.$router.push({
        name: 'nonsc-project-home', params: { projectId }
      })
    }
  }
}
</script>

<style lang="css" scoped>

.page-content {
  height: 100%;
}

.content-wrap {
  display     : grid;
  gap         : var(--size-sm);
  background  : white;
}
section[section=content] {
  flex      : 1;
  overflow  : auto;
}
section[section=action] {
  background-color  : white;
  border-top        : 1px solid #efefef;
}
section[section=action] .content-wrap {
  padding: 0;
}
section[section=action] .action-group {
  justify-content: space-between;
}

.content-action {
  display         : flex;
  justify-content : space-between;
  align-items     : center;
}

.action-group {
  display : flex;
  gap     : var(--size-sm);
}

input[type=file] {
  display: none;
}

@media screen and (max-width: 1024px) {

  .content-action {
    flex-direction  : column;
    gap             : var(--size-xs);
  }

  .content-action [content] {
    width: 100%;
  }
  
  section[section=action] .content-action {
    gap             : var(--size-sm);
    flex-direction  : row;
  }
}

@media screen and (max-width: 480px) {

  .action-group button {
    flex: 1;
  }
  
  section[section=action] .content-action .el-button {
    flex: 1;
  }
}

</style>



// WEBPACK FOOTER //
// src/features/nonsc/pages/project-import/NonScImportHome.vue